import { useMemo } from 'react'
import auth from '../../../../api/auth/hooks'
import { OfferEmailSettingsGroup, OfferTemplateId } from '../../../../api/offers/types'
import { offerBaseInputs } from '../../../../common/forms/generalRealEstate/inputs'
import { offerValidation } from '../../../../common/forms/generalRealEstate/validations'

export const useOfferFormConfig = (activeTab: string, offerType: string, offerEmailSettingsGroup?: OfferEmailSettingsGroup) => {
    const currentLang = localStorage.getItem('i18nextLng')

    const { data: currentAgentId } = auth.CurrentAgent.useQuery({ select: (data) => data.id })

    const inputs = useMemo(() => offerBaseInputs(activeTab), [activeTab])

    const validationConfig = useMemo(
        () =>
            offerValidation({
                agent: {
                    id: currentAgentId,
                },
                offerTemplate: offerType === 'property' ? OfferTemplateId.PROPERTY_TEMPLATE_1 : OfferTemplateId.PROJECT_TEMPLATE,
                offerLocale: currentLang,
                offerType: offerType,
                offerEmailSettingsGroup,
            }),
        [currentAgentId, currentLang, offerType, offerEmailSettingsGroup]
    )

    return {
        inputs,
        validationConfig,
    }
}
